// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportModalFilter_root__cjUVE","footer":"ReportModalFilter_footer__1sQiG"};